import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import StorePage from "@/pages/StorePage";
import ProductPage from "@/pages/ProductPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AdminPage from "@/pages/AdminPage";
import CheckoutPage from "@/pages/CheckoutPage";
import CustomerAccountPage from "@/pages/CustomerAccountPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import MerchantLayout from "@/pages/merchant/MerchantLayout";
import MerchantHome from "@/pages/merchant/MerchantHome";
import MerchantOnboarding from "@/pages/merchant/MerchantOnboarding";
import MerchantStoreEdit from "@/pages/merchant/MerchantStoreEdit";
import MerchantProducts from "@/pages/merchant/MerchantProducts";
import MerchantProductEdit from "@/pages/merchant/MerchantProductEdit";
import MerchantOrders from "@/pages/merchant/MerchantOrders";
import MerchantOrderDetail from "@/pages/merchant/MerchantOrderDetail";
import Layout from "@/components/layout/Layout";
import ScrollToTop from "@/components/layout/ScrollToTop";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

function AppRouter() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/registro" element={<RegisterPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/cuenta" element={<CustomerAccountPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/terminos" element={<TermsPage />} />
                <Route path="/privacidad" element={<PrivacyPage />} />

                {/*
                  El marketplace público (ExplorePage / SearchPage) quedó fuera
                  del router a propósito: la landing ya no da a conocer tiendas
                  ni productos. Los archivos siguen en el repo por si se
                  reactiva el descubrimiento público.
                */}

                {/* Merchant area */}
                <Route path="/dashboard" element={<MerchantLayout />}>
                    <Route index element={<MerchantHome />} />
                    <Route path="onboarding" element={<MerchantOnboarding />} />
                    <Route path="store" element={<MerchantStoreEdit />} />
                    <Route path="products" element={<MerchantProducts />} />
                    <Route path="products/new" element={<MerchantProductEdit />} />
                    <Route
                        path="products/:productId/edit"
                        element={<MerchantProductEdit />}
                    />
                    <Route path="orders" element={<MerchantOrders />} />
                    <Route path="orders/:orderId" element={<MerchantOrderDetail />} />
                </Route>

                {/* Public marketplace */}
                <Route path="/:storeSlug" element={<StorePage />} />
                <Route path="/:storeSlug/:productSlug" element={<ProductPage />} />
            </Routes>
        </Layout>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <ScrollToTop />
                    <AppRouter />
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="bottom-left" />
        </div>
    );
}

export default App;
